import { Navigate, Route, Routes } from "react-router-dom";
import { DEPARTMENTS } from "@neus/shared";
import { Layout } from "./components/layout/Layout";
import { AccountPage, SignInPage } from "./pages/Account";
import { OrdersPage, PickupOrderPage } from "./pages/Orders";
import { AdminAllContractorPricingPage, AdminContractorPage, AdminContractorsPage } from "./pages/Admin";
import { AdminCompletedOrdersPage, AdminOrderPage, AdminOrdersPage } from "./pages/AdminOrders";
import { CartPage } from "./pages/Cart";
import { CheckoutPage } from "./pages/Checkout";
import {
  ContractorOrderPage,
  ContractorOrdersPage,
  ContractorsPage,
  NewContractorOrderPage,
} from "./pages/Contractors";
import { BrandsPage, DepartmentsPage } from "./pages/Directory";
import { OrderCompletePage } from "./pages/OrderComplete";
import { ProductDetailPage } from "./pages/ProductDetail";
import { AllProductsPage, BrandPage, DepartmentPage, SearchPage } from "./pages/ProductList";
import { ContentPage } from "./components/content/ContentPage";
import { NOT_FOUND_PAGE, PAGES } from "./content";
import { contractorAdmin, features } from "./features";

/** The site's routes. An element of its own, so the build can list them for the host's routes. */
export const APP_ROUTES = (
  <>
    <Route path="/products" element={<AllProductsPage />} />
    <Route path="/products/:sku" element={<ProductDetailPage />} />
    <Route path="/departments" element={<DepartmentsPage />} />
    {/* Department URLs match neushardware.com, e.g. /power-tools, /paint, /gift-cards */}
    {DEPARTMENTS.map((d) => (
      <Route key={d.slug} path={`/${d.slug}`} element={<DepartmentPage slug={d.slug} />} />
    ))}
    <Route path="/brands" element={<BrandsPage />} />
    <Route path="/brands/:slug" element={<BrandPage />} />
    <Route path="/search" element={<SearchPage />} />
    {/* A feature that's off has no routes: its pages show "not found". */}
    {features.accounts && (
      <>
        <Route path="/account" element={<AccountPage />} />
        <Route path="/account/sign-in" element={<SignInPage />} />
        <Route path="/account/orders" element={<OrdersPage />} />
        {features.payInStorePickup && <Route path="/account/orders/:id" element={<PickupOrderPage />} />}
      </>
    )}
    {features.contractorProgram && (
      <>
        <Route path="/contractors" element={<ContractorsPage />} />
        <Route path="/contractor/orders" element={<ContractorOrdersPage />} />
        <Route path="/contractor/orders/new" element={<NewContractorOrderPage />} />
        <Route path="/contractor/orders/:id" element={<ContractorOrderPage />} />
      </>
    )}
    {features.staffTools && (
      <>
        <Route path="/admin" element={<Navigate to="/admin/orders" replace />} />
        <Route path="/admin/orders" element={<AdminOrdersPage />} />
        <Route path="/admin/orders/completed" element={<AdminCompletedOrdersPage />} />
        <Route path="/admin/orders/:kind/:key" element={<AdminOrderPage />} />
      </>
    )}
    {contractorAdmin && (
      <>
        <Route path="/admin/contractors" element={<AdminContractorsPage />} />
        <Route path="/admin/contractors/:id" element={<AdminContractorPage />} />
      </>
    )}
    {/* Off, it's not found, rather than the :id page for a contractor called "all". */}
    <Route
      path="/admin/contractors/all"
      element={
        features.allContractorPricing ? <AdminAllContractorPricingPage /> : <ContentPage page={NOT_FOUND_PAGE} />
      }
    />
    <Route path="/cart" element={<CartPage />} />
    {features.cardPayments && (
      <>
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order/complete" element={<OrderCompletePage />} />
      </>
    )}
    {/* The home page and every other marketing page: brands/<BRAND>/pages/*.json. */}
    {PAGES.map((p) => (
      <Route key={p.path} path={p.path} element={<ContentPage page={p} />} />
    ))}
    <Route path="*" element={<ContentPage page={NOT_FOUND_PAGE} />} />
  </>
);

export function App() {
  return (
    <Layout>
      <Routes>{APP_ROUTES}</Routes>
    </Layout>
  );
}
